export default __webpack_public_path__ + "static/media/HATCHBACK.d1b73dd7.png";